<template>
    <div class="content-width">
      <h2 class="text-3xl">eSIM Profil einrichten</h2>
      <div class="container-box eSIM-m-b">
        <div class="content-limiter">
          <ESimManualInput
            :smdp="eSimQRInformation.smdpPlus"
            :activationCode="eSimQRInformation.code.activationCode"
            :ePin="eSimQRInformation.code.confirmationCode"
          ></ESimManualInput>
        </div>
      </div>
      <div class="container-box">
        <div class="content-limiter">
          <ESimQRCode :qrCode="eSimQRInformation.code.qrCode" :ePin="eSimQRInformation.code.confirmationCode"></ESimQRCode>
        </div>
      </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import ESimQRCode from './ESimQrCode.vue'
import ESimManualInput from './ESimManualInput.vue'

export default {
  name: 'ESimSetup',
  components: {
    ESimQRCode,
    ESimManualInput
  },
  data() {
    return {
      eSimQRInformation: {
        code: {
          activationCode: '',
          confirmationCode: '',
          qrCode: ''
        },
        smdpPlus: ''
      }
    }
  },
  computed: {},
  methods: {},
  mixins: [],
  apollo: {
    eSimQRInformation: function() {
      return wrapQuery(
        gql`
          query eSimQRInformation {
            eSimQRInformation(size: 143) {
              code {
                activationCode
                confirmationCode
                ... on ESimQR {
                  qrCode
                }
              }
              smdpPlus
            }
          }
        `,
        this,
        'eSimQRInformation'
      )
    }
  }
}
</script>
